import { render, staticRenderFns } from "./BindProjectDomain.vue?vue&type=template&id=08a8c413"
import script from "./BindProjectDomain.vue?vue&type=script&lang=js"
export * from "./BindProjectDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports